import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const OtpComponentLzy = lazyLoader(
  () => import('./Otp' /* webpackChunkName: "otp" */),
);

const OtpComponent = () => {
  return (
    <Suspense fallback={null}>
      <OtpComponentLzy />
    </Suspense>
  );
};

export default OtpComponent;
